<form [formGroup]="form">
  <div class="block justify-center overscroll-contain w-full">
    @if (vinAssignment; as assignment) {
      @if (showHidden || !assignment.hidden) {
        <vs-form-field
          class="col-span-2 w-full"
          [config]="{ label: (assignment.displayLabel || assignment.property.name) + ':' }"
        >
          @if (assignment.helpText) {
            <span slot="hint" class="text-gray-600 text-sm">{{ assignment.helpText }}</span>
          }
          <vs-input-group class="w-full">
            <input
              vsInput
              type="text"
              class="w-full rounded-b-none"
              [formControlName]="assignment.property.valueKey"
              placeholder="Enter vehicle VIN"
            />
            <button
              vs-button
              class="flex min-w-fit rounded-b-none"
              vsTooltip="Autofill Vehicle information from VIN"
              theme="primary"
              [disabled]="!vinControl?.value"
              (click)="useVIN(vinControl?.value || '')"
            >
              <vs-icon name="file-06"> </vs-icon>
            </button>
          </vs-input-group>
        </vs-form-field>
      }
    }
    <div class="border justify-center rounded-b-md w-full block grid-cols-2 gap-3 overscroll-contain -mt-px">
      <div class="flex flex-row gap-2 items-center">
        <button class="self-center" vs-icon-button appearance="clear" size="md" (click)="toggle()">
          <vs-icon [name]="expanded ? 'chevron-up' : 'chevron-down'"></vs-icon>
        </button>
        <label class="font-semibold text-sm">Vehicle Information:</label>
        @if (getSummaryValue('make'); as make) {
          <label class="text-sm text-gray-700 font-semibold gap-2 text-center">
            {{ make }}
          </label>
        }
        @if (getSummaryValue('model'); as model) {
          <label class="text-sm text-gray-700 font-semibold gap-2 text-center">
            {{ model }}
          </label>
        }
        @if (getSummaryValue('year'); as year) {
          <label class="text-sm text-gray-700 font-semibold gap-2 text-center">
            {{ year }}
          </label>
        }
        @if (form.invalid) {
          <span class="text-danger text-xs font-medium">Required details missing</span>
        }
      </div>

      @if (expanded) {
        <div class="px-2 py-3 w-full">
          <ng-container *ngFor="let assignment of visibleExpandedAssignments">
            @if (showHidden || !assignment.hidden) {
              <vs-property-input-form-field
                class="col-span-2 pt-2"
                [property]="assignment.property"
                [required]="assignment.required"
                [hidden]="assignment.hidden"
                [showHidden]="showHidden"
                [displayLabel]="assignment.displayLabel"
                [helpText]="assignment.helpText"
                [formControlName]="assignment.property.valueKey"
              >
              </vs-property-input-form-field>
            }
          </ng-container>

          @if (vehicle$ | async; as vehicle) {
            <div class="flex flex-col gap-1 mt-4">
              <h3
                class="text-sm text-gray-700 font-medium cursor-pointer"
                [class.mb-3]="detailsExpanded"
                (click)="detailsExpanded = !detailsExpanded"
              >
                All Vehicle Details:
                @if ((vehicle | values | truthify)?.length; as propCount) {
                  <vs-badge class="ml-1">
                    {{ detailsExpanded ? '' : 'Show ' }} {{ propCount }}
                    {{ propCount !== 1 ? 'Properties' : 'Property' }}
                    <vs-icon
                      class="ml-1"
                      [name]="detailsExpanded ? 'x-close' : 'info-circle'"
                      [type]="detailsExpanded ? 'line' : 'solid'"
                    ></vs-icon>
                  </vs-badge>
                }
              </h3>
              @if (detailsExpanded) {
                <ng-container *ngFor="let entry of vehicle | keyvalue">
                  @if (entry.value) {
                    <p class="text-xs ml-2">
                      <strong>{{ entry.key }}:</strong>{{ entry.value }}
                    </p>
                  }
                </ng-container>
              }
            </div>
          }
        </div>
      }
    </div>
    @if (vinControl?.touched && vinControl?.hasError('required')) {
      <span class="flex-col justify-center text-danger-500 font-medium text-sm ml-1 mt-1" slot="warning">
        VIN is required!
      </span>
    }
  </div>
</form>
